import type { Dictionary } from '../i18n/registry.js';

/**
 * `value` is the name a system style carries in the seed (`packages/db/prisma/seed.ts`) — an
 * identifier the API matches on, not display text. It happens to be Russian because the seed
 * was written first for that market; the field shows the active locale's label instead and
 * sends the stored name back, so neither brand's interface ever displays another language.
 */
export const STORY_STYLE_SUGGESTIONS = [
  { value: 'Гиперреалистично', label: 'hyperrealistic' },
  { value: 'Аниме', label: 'anime' },
  { value: 'Мягкий мультфильм (как Pixar)', label: 'softCartoon' },
  { value: 'Акварель', label: 'watercolor' },
  { value: 'Плоская детская иллюстрация', label: 'flat' },
  { value: 'Классическая книжная графика', label: 'classic' },
] as const;

/** The stored name as the interface shows it: a system style's label, otherwise as typed. */
export function styleDisplayName(stored: string, t: Dictionary): string {
  const suggestion = STORY_STYLE_SUGGESTIONS.find((item) => item.value === stored);
  return suggestion ? t.builder.styleSuggestions[suggestion.label] : stored;
}

/** What to send for a typed value: the stored name when it is a system style's label. */
export function styleStoredName(typed: string, t: Dictionary): string {
  const normalized = typed.trim().toLocaleLowerCase();
  const suggestion = STORY_STYLE_SUGGESTIONS.find(
    (item) =>
      t.builder.styleSuggestions[item.label].toLocaleLowerCase() === normalized ||
      item.value.toLocaleLowerCase() === normalized,
  );
  return suggestion ? suggestion.value : typed.trim();
}
